module.exports = __webpack_public_path__ + "static/media/sfaa-bg1.f15a349f.png";